import { useState, useEffect } from "react";

export function useCookieConsent() {
  const [showConsent, setShowConsent] = useState(false);
  const [consentGiven, setConsentGiven] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const consent = localStorage.getItem("cookie-consent");

    if (consent === null) {
      // First time visitor - show consent modal after a short delay
      const timer = setTimeout(() => {
        setShowConsent(true);
      }, 2000);

      return () => clearTimeout(timer);
    } else {
      setConsentGiven(consent === "accepted");
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setConsentGiven(true);
    setShowConsent(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookie-consent", "declined");
    setConsentGiven(false);
    setShowConsent(false);
  };

  return {
    showConsent,
    consentGiven,
    acceptCookies,
    declineCookies,
  };
}
